const { hasTrainingSystemAccess } = require('./trainingSystemAccess');

/**
 * Vuex action: get sgfs from server and add to joinedProblem records.
 * "queue" is an array of problemIds.
 */
async function fetchSgfs({ state, getters, commit }, queue) {
  // if user doesn't have membership, don't fetch
  const hasAccess = hasTrainingSystemAccess(
    getters.isLoggedIn,
    state.user,
    state.membership,
    new Date(),
  );
  if (!hasAccess) return;

  // if a problem in the queue already has an sgf, do not re-fetch.
  const problemIdsNeedingSgfs = queue.filter((id) => {
    const jp = state.joinedProblems.find((jpr) => jpr.problemId === id);
    return jp && !jp.sgf;
  });

  // if nothing to fetch, exit
  if (problemIdsNeedingSgfs.length === 0) return;

  // problem string is comma delimited problemId's that need sgfs
  const problemString = problemIdsNeedingSgfs.toString();

  let response;
  try {
    response = await getters.apiGet(`fetch/sgfs?ids=${problemString}`);
  } catch (e) {
    console.log(e);
    commit('pushFlash', {
      title: 'There was an error while fetching problems:',
      message: e.message,
      variant: 'warning',
      duration: 2000,
    });
    return;
  }
  response.data.forEach((dataEl) => {
    // add sgf to joinedProblems
    const i = state.joinedProblems.findIndex((jp) => jp.problemId === dataEl.id);
    commit('changeExistingStateValue', {
      table: 'joinedProblems',
      change: { sgf: dataEl.sgf },
      index: i,
    });
  });
}

module.exports = { fetchSgfs };
